/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon16Light = forwardRef('ArrowAUpRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 3a.5.5 0 0 0 0 1h5.793l-8.147 8.146a.5.5 0 0 0 .708.708L12 4.707V10.5a.5.5 0 0 0 1 0v-6A1.5 1.5 0 0 0 11.5 3h-6Z" })));
});
